module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-gris.93c474d4.svg";